import Cookie from "js-cookie";
const user = {
  namespaced: true, // 开启命名空间，调用时需指定模块名
  state: {
    // 完整的用户信息对象
    userInfo: {} || localStorage.getItem("userInfo") || "",
    // 用户ID
    userId: "" || Cookie.get("userId") || "",
    // 用户名
    userName: "" || Cookie.get("userName") || "",
    // 访问令牌
    token: null || Cookie.get("token") || "",
    // refreshToken: null,
    // 登录状态
    isLogin: false || Cookie.get("isLogin") || false,
    // 昵称
    nickName: "" || Cookie.get("nickName") || "",
  },
  mutations: {
    // 修改token
    setToken(state, token) {
      state.token = token;
    },

    // 设置刷新token
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken;
    },

    // 设置登录状态
    setLoginStatus(state, status) {
      state.isLogin = status;
    },

    // 存储用户信息
    setUserInfo(state, info) {
      // 1. 先保存原始的用户信息到 state.userInfo 对象
      state.userInfo = {
        // 复制所有其他用户信息
        ...info,
      };
      console.log("vuex中setUserInfo方法用户信息存储上了", state);
      // // 2. 同时更新各个独立的字段（保持向后兼容）
      state.userId = info.userId || "";
      state.userName = info.username || "";
      state.isLogin = info.isLogin || false;
      state.nickName = info.nickName || "";
      // // 存储其他需要的用户信息
      // Object.keys(info).forEach(key => {
      //   if (!(key in state)) {
      //     state[key] = info[key];
      //   }
      // });
    },

    // 清除用户信息（登出）
    clearUserInfo(state) {
      state.userInfo = {};
      state.userId = "";
      state.userName = "";
      state.token = null;
      // state.refreshToken = null;
      state.isLogin = false;
      state.nickName = "";
      console.log("vuex中退出登录clearUserInfo方法",this.state);
    },
  },
  actions: {
    // 异步登录
    login({ commit, dispatch }, userData) {
      return new Promise((resolve, reject) => {
        // 暂时删除
        commit("setToken", userData.token);
        // commit("setRefreshToken", userData.refreshToken);
        commit("setUserInfo", userData);

        // 存储完整用户信息到Cookie以便持久化
        if (userData.token) {
          // 使用js-cookie存储数据
          Cookie.set('token', userData.token);
          // if (userData.refreshToken) {
          //   Cookie.set('refreshToken', userData.refreshToken);
          // }
          // 存储完整的用户信息对象
          localStorage.setItem("userInfo", JSON.stringify(userData));
          // 存储其他必要字段到Cookie
          Cookie.set("isLogin", userData.isLogin.toString());
          // 存储用户ID
          Cookie.set("userId", userData.userId);
          // 存储用户名
          Cookie.set("userName", userData.username || '');
          // 存储昵称
          Cookie.set("nickName", userData.nickName || '');
        }

        // 登录成功后，并行获取所有必要的数据（轮播图、行业分类等）
        try {
          // 使用Promise.all并行获取数据，不阻塞登录流程
          dispatch('dataCache/fetchAllDataAfterLogin', null, { root: true })
            .then(() => {
              console.log('登录后数据获取完成')
            })
            .catch(error => {
              console.error('登录后数据获取失败，但不影响登录流程:', error)
            });
        } catch (error) {
          console.error('登录后数据获取处理异常:', error)
        }

        resolve(true);
      });
    },

    // 登出操作
    logout({ commit }) {
      commit("clearUserInfo");
      // 使用js-cookie移除数据
      Cookie.remove("token");
      // Cookie.remove("refreshToken");
      Cookie.remove("userInfo");
      Cookie.remove("isLogin");
      Cookie.remove("userId");
      Cookie.remove("userName");
      Cookie.remove("nickName");
      localStorage.removeItem("userInfo");
    },

    // 从Cookie恢复登录状态
    restoreLoginState({ commit }) {
      const token = Cookie.get("token");
      // const refreshToken = Cookie.get("refreshToken");
      const userInfoStr = localStorage.getItem("userInfo");

      if (token) {
        commit("setToken", token);
        // commit("setRefreshToken", refreshToken);
        commit("setLoginStatus", true);

        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            commit("setUserInfo", userInfo);
          } catch (e) {
            console.error("解析用户信息失败:", e);
          }
        }
      }
    },
  },
  getters: {
    // 计算是否登录
    isLogin(state) {
      return !!state.token;
    },

    // 获取完整用户信息
    userInfo(state) {
      console.log(state);
      return state.userInfo;
    },
  },
};

export default user;
